import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";

interface StatCardProps extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const StatCard = forwardRef<HTMLDivElement, StatCardProps>(
  ({ content, styles = {}, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles });

    return (
      <div
        ref={ref}
        className={classNames(
          "wb-flex wb-w-full wb-flex-col wb-gap-2 wb-rounded-[1.25rem] wb-border wb-p-5",
          className,
        )}
        style={inlineStyles}
        {...rest}
      >
        {content}
      </div>
    );
  },
);
StatCard.displayName = "StatCard";
